<template lang='pug'>
  v-dialog(v-model="dialog" persistent max-width="500")
    v-btn(:disabled="disableds" slot="activator" title='Withdraw' depressed large color="error" @click="dialog = true").ml-2
        v-icon cancel
        | &nbsp; Withdraw
    v-card()
      v-card-title(class="headline grey lighten-3 mb-3") Withdraw Memo
      p(class="pl-6 pt-3" style="font-size: 14px;") 
        span.red--text *
        | Leave a comment for the memo
      v-card-text
        v-layout(wrap)
          v-flex(xs12)
            v-textarea(
              v-model="comment"
              filled
              label="Description"
              counter="150"
              :rules="[rules.length(150)]"
            )
      v-card-actions.pb-5
        v-spacer
        v-btn(
          depressed
          @click="dialog = false"
          class="pl-4 pr-4"
        )
          | Close
        div(class="text-xs-center pl-4")
          v-btn(
            :disabled="!isInputValid" 
            color="blue-secondary" 
            depressed 
            @click="dialog2 = true"
          ) Submit
          v-dialog(
            v-model="dialog2"
            hide-overlay
            persistent
            width="300")
            v-card(color="primary" dark)
              v-card-text Processing. Please wait!
                v-progress-linear(indeterminate color="white" class="mb-0")

</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: 'WithdrawDialog',
  props: {
    imId: String,
    type: Number,
    creator: Boolean,
    disableds: Boolean
  },
  data: () => ({
    dialog: false,
    disableds: false,
    dialog2: false,
    duplicate: false,
    comment: '',
    rules: {
      length: len => v => (v || '').length <= len || `Comment must be less than 150 characters`,
    },
  }),
  computed: {
    ...mapState(["API_URL"]),
    isInputValid() {
      return this.comment != '' && this.comment.length <= 150
    }
  },
  watch: {
    dialog2 () {
       axios.put(process.env.VUE_APP_API_OLD+`/api/withdraw/requests`, {_id: this.imId, user_bu: this.$store.state.dataUsers.user._id, comment: this.comment})
        .then((res) => {
            this.$toasted.error("Memo has been success withdraw", { icon : 'check_circle'});
            this.dialog = false
             this.$router.push(`/my-request`)

        }).catch((err) => {
          if (err.response.data.message) {
            this.$toasted.error(err.response.data.message, { icon: 'error' });
          } else if (err.response.data.error) {
            this.$toasted.error(err.response.data.error, { icon: 'error' });
          } else {
            this.$toasted.error(err, { icon: 'error' });
          }
        });
    
    }
  }
};
</script>
